import { defineMessages } from 'react-intl';

export const msgs = defineMessages({
  cookiesPolicy: {
    id: `footer_link_cookies`,
  },

  privacyPolicy: {
    id: `footer_link_privacy`,
  },

  termsOfUse: {
    id: `footer_link_terms`,
  },
});
